import * as z from "zod";

import { PaymentMethod } from "@modules/checkout/enums/payment-method";
import { PaymentStatus } from "@modules/checkout/enums/payment-status";
import { RawDateTimeSchema } from "@shared/schemas/date";

import { PaymentStatusSchema } from "./payment-status.schema";

export const BoletoPaymentAttemptSchema = z
  .object({
    ExtraData: z
      .object({
        Code: z.int(),
        Identifier: z.string(),
        NossoNumero: z.string(),
        DueAt: RawDateTimeSchema,
        DigitableLine: z.string(),
        Link: z.string(),
      })
      .nullable(),
    Status: PaymentStatusSchema.nullable().optional().default(null),
    Method: z.literal(PaymentMethod.Boleto),
  })
  .transform((payload) => {
    if (payload.Status === PaymentStatus.Created || payload.Status === PaymentStatus.Failed) {
      return { ...payload, ExtraData: null };
    }
    return payload;
  });
